<template>
  <div class="comp-textarea">
    <jw-typography-paragraph class="ellipsis-content" :ellipsis="{ rows: 5, showTooltip: true }">
      <template v-if="fielterText">
        {{ fielterText }}
      </template>
      <span class="field-content-empty" v-else>
        {{ emptyText }}
      </span>
    </jw-typography-paragraph>
  </div>
</template>

<script setup>
import { tools } from '@/utils/tools';
import { computed } from 'vue';
import { emptyText } from '@/utils/const';
const props = defineProps({
  fieldValue: {
    type: String,
    default: ''
  },
  fieldInfo: {
    type: Object,
    default: () => {}
  }
});

const fielterText = computed(() => {
  if (props.fieldInfo?.fieldType != 26) return props.fieldValue;
  let result = props.fieldValue;
  if (!result) return '';
  // 如果是单行文本则去掉所有换行和空格 以及所有的换行标签、p标签
  result = tools.handleRichText(result);
  result = result.replace(/<img/g, '&nbsp;&nbsp;<img class="rich-text-img" height="60"');
  // 去除img标签内联样式，避免影响详情页展示
  result = result.replace(/<img[^>]*style="[^"]*"[^>]*>/gi, function (match) {
    return match.replace(/ style="[^"]*"/gi, '');
  });
  return result;
});
</script>
<style scoped lang="less">
@import './textarea.less';
</style>
